import React from "react";
import ReactDOM from "react-dom";

const kebabToPascal = (kebabCase) => kebabCase.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

const getPropsFromElement = (element) => {
    const props = Object.fromEntries(element.getAttributeNames().map(attr => [kebabToPascal(attr), element.getAttribute(attr)]))
    return {
        ...props,
        HTMLElement: element
    }
}

export const renderToElement = (element, component) => {
    // const root = createRoot(element);
    ReactDOM.render(React.createElement(component, getPropsFromElement(element)), element)
}

export const render = (querySelector, component) => {
    let element = document.querySelector(querySelector);
    if (!element) {
        console.warn(`There is no element corresponding to ${querySelector}`);
        return;
    }
    renderToElement(element, component);
}

export default render;
